import { connect } from 'react-redux';
import { getBrand } from 'app/api/redux-watson/watson-config-selectors';

const mapStateToProps = state => ({
  brand: getBrand(state),
});

export default function withBrand(BrandedComponent) {
  return connect(mapStateToProps)(BrandedComponent);
}
